import React, { useEffect } from 'react';

// Import the images for each artboard
// Adjust these paths to match your project structure
import artboard1Image from '../assets/Parliament-Artboard_1.png';
import artboard2Image from '../assets/Parliament-Artboard_2.png';
import artboard3Image from '../assets/Parliament-Artboard_3.png';

/**
 * Parliament Component
 * 
 * A responsive visualization showing median age by sex with
 * three different layouts for various screen sizes.
 */
const Parliament = () => {
  useEffect(() => {
    // Handle the ai2html resize function if it exists
    if (window.ResizeAi2html && typeof window.ResizeAi2html === 'function') {
      window.ResizeAi2html();
      
      // Add resize listener
      window.addEventListener('resize', window.ResizeAi2html);
      
      // Cleanup on unmount
      return () => {
        window.removeEventListener('resize', window.ResizeAi2html);
      };
    }
  }, []);

  // This is the ai2html output with image sources replaced
  const htmlContent = `

 

  <!-- Generated by ai2html v0.117.6 - 2025-03-08 07:05 -->
  <!-- ai file: Parliament.ai -->
  <style media="screen,print">
	  #g-Parliament-box ,
	  #g-Parliament-box .g-artboard {
		  margin:0 auto;
	  }
	  #g-Parliament-box p {
		  margin:0;
	  }
	  #g-Parliament-box .g-aiAbs {
		  position:absolute;
	  }
	  #g-Parliament-box .g-aiImg {
		  position:absolute;
		  top:0;
		  display:block;
		  width:100% !important;
	  }
	  #g-Parliament-box .g-aiSymbol {
		  position: absolute;
		  box-sizing: border-box;
	  }
	  #g-Parliament-box .g-aiPointText p { white-space: nowrap; }
	  #g-Parliament-Artboard_1 {
		  position:relative;
		  overflow:hidden;
	  }
	  #g-Parliament-Artboard_1 p {
		  font-weight:700;
		  line-height:17px;
		  opacity:1;
		  letter-spacing:0em;
		  font-size:14px;
		  text-align:left;
		  color:rgb(33,37,41);
		  text-transform:none;
		  padding-bottom:0;
		  padding-top:0;
		  mix-blend-mode:normal;
		  font-style:normal;
		  height:auto;
		  position:static;
	  }
	  #g-Parliament-Artboard_1 .g-pstyle0 {
		  font-weight:300;
		  height:17px;
	  }
	  #g-Parliament-Artboard_1 .g-pstyle1 {
		  font-weight:400;
	  }
	  #g-Parliament-Artboard_1 .g-cstyle0 {
		  font-weight:700;
	  }
	  #g-Parliament-Artboard_1 .g-cstyle1 {
		  font-weight:400;
	  }
	  #g-Parliament-Artboard_2 {
		  position:relative;
		  overflow:hidden;
	  }
	  #g-Parliament-Artboard_2 p {
		  font-weight:700;
		  line-height:17px;
		  opacity:1;
		  letter-spacing:0em;
		  font-size:14px;
		  text-align:left;
		  color:rgb(33,37,41);
		  text-transform:none;
		  padding-bottom:0;
		  padding-top:0;
		  mix-blend-mode:normal;
		  font-style:normal;
		  height:auto;
		  position:static;
	  }
	  #g-Parliament-Artboard_2 .g-pstyle0 {
		  font-weight:300;
		  height:17px;
	  }
	  #g-Parliament-Artboard_2 .g-pstyle1 {
		  font-weight:400;
	  }
	  #g-Parliament-Artboard_2 .g-pstyle2 {
		  text-align:right;
	  }
	  #g-Parliament-Artboard_2 .g-cstyle0 {
		  font-weight:700;
	  }
	  #g-Parliament-Artboard_2 .g-cstyle1 {
		  font-weight:400;
	  }
	  #g-Parliament-Artboard_3 {
		  position:relative;
		  overflow:hidden;
	  }
	  #g-Parliament-Artboard_3 p {
		  font-weight:700;
		  line-height:16px;
		  opacity:1;
		  letter-spacing:0em;
		  font-size:13px;
		  text-align:left;
		  color:rgb(33,37,41);
		  text-transform:none;
		  padding-bottom:0;
		  padding-top:0;
		  mix-blend-mode:normal;
		  font-style:normal;
		  height:auto;
		  position:static;
	  }
	  #g-Parliament-Artboard_3 .g-pstyle0 {
		  font-weight:300;
		  height:16px;
	  }
	  #g-Parliament-Artboard_3 .g-pstyle1 {
		  font-weight:400;
	  }
	  #g-Parliament-Artboard_3 .g-cstyle0 {
		  font-weight:700;
	  }
	  #g-Parliament-Artboard_3 .g-cstyle1 {
		  font-weight:400;
	  }

	    /* Add media queries to control which artboard shows at different screen sizes */
    @media (min-width: 930px) {
      #g-Parliament-Artboard_2, #g-Parliament-Artboard_3 {
        display: none;
      }
    }
    
    @media (min-width: 560px) and (max-width: 929px) {
      #g-Parliament-Artboard_1, #g-Parliament-Artboard_3 {
        display: none;
      }
    }
    
    @media (max-width: 559px) {
      #g-Parliament-Artboard_3, #g-Parliament-Artboard_1 {
        display: none;
      }
    }
  
  
  </style>
  
  <div id="g-Parliament-box" class="ai2html">
  
	  <!-- Artboard: Artboard_1 -->
	  <div id="g-Parliament-Artboard_1" class="g-artboard" style="width:800px; height:290.867840201005px;" data-aspect-ratio="2.75" data-min-width="800">
  <div style=""></div>
		  <img id="g-Parliament-Artboard_1-img" class="g-Parliament-Artboard_1-img g-aiImg" alt="" src="${artboard1Image}"/>
		  <div id="g-ai0-1" class="g-md g-aiAbs" style="top:4.1256%;left:2.5197%;width:16%;">
			  <p>Bicameral congress </p>
		  </div>
		  <div id="g-ai0-2" class="g-md g-aiAbs" style="top:4.1256%;left:21.18%;width:28.125%;">
			  <p>Unicameral congress/ parliament </p>
		  </div>
		  <div id="g-ai0-3" class="g-md g-aiAbs g-aiPointText" style="top:16.6348%;margin-top:-9.4px;left:52.3121%;width:38px;">
			  <p class="g-pstyle0">55</p>
		  </div>
		  <div id="g-ai0-4" class="g-md g-aiAbs g-aiPointText" style="top:16.6348%;margin-top:-9.4px;left:86.2872%;width:38px;">
			  <p class="g-pstyle0">65</p>
		  </div>
		  <div id="g-ai0-5" class="g-md g-aiAbs g-aiPointText" style="top:16.6348%;margin-top:-9.4px;left:18.3382%;width:38px;">
			  <p class="g-pstyle0">45</p>
		  </div>
		  <div id="g-ai0-6" class="g-md g-aiAbs g-aiPointText" style="top:16.6348%;margin-top:-9.4px;left:1.3048%;width:96px;">
			  <p class="g-pstyle0">40 years old</p>
		  </div>
		  <div id="g-ai0-7" class="g-md g-aiAbs g-aiPointText" style="top:16.6348%;margin-top:-9.4px;left:36.1173%;width:38px;">
			  <p class="g-pstyle0">50</p>
		  </div>
		  <div id="g-ai0-8" class="g-md g-aiAbs g-aiPointText" style="top:16.6348%;margin-top:-9.4px;left:69.4298%;width:38px;">
			  <p class="g-pstyle0">60</p>
		  </div>
		  <div id="g-ai0-9" class="g-md g-aiAbs" style="top:30.2543%;left:29.1268%;width:6.625%;">
			  <p class="g-pstyle1">Bahrain</p>
		  </div>
		  <div id="g-ai0-10" class="g-md g-aiAbs" style="top:32.3171%;left:38.3115%;width:12.875%;">
			  <p class="g-pstyle1">Philippines <span class="g-cstyle0">51</span></p>
		  </div>
		  <div id="g-ai0-11" class="g-md g-aiAbs" style="top:50.1946%;left:54.5186%;width:9%;">
			  <p><span class="g-cstyle1">Japan</span> 55.6</p>
		  </div>
		  <div id="g-ai0-12" class="g-md g-aiAbs" style="top:55.0078%;left:87.5581%;width:12.625%;">
			  <p class="g-pstyle1">Cambodia <span class="g-cstyle0">66.5</span></p>
		  </div>
		  <div id="g-ai0-13" class="g-md g-aiAbs" style="top:67.3846%;left:59.8516%;width:9%;">
			  <p><span class="g-cstyle1">US</span> 57.7</p>
		  </div>
		  <div id="g-ai0-14" class="g-md g-aiAbs" style="top:87.6687%;left:23.2048%;width:9.25%;">
			  <p class="g-pstyle1">Rwanda <span class="g-cstyle0">49</span></p>
		  </div>
	  </div>
  
	  <!-- Artboard: Artboard_2 -->
	  <div id="g-Parliament-Artboard_2" class="g-artboard" style="max-width: 330px;max-height: 1052px" data-aspect-ratio="0.314" data-min-width="0" data-max-width="559">
  <div style="padding: 0 0 318.8772% 0;"></div>
		  <img id="g-Parliament-Artboard_2-img" class="g-Parliament-Artboard_2-img g-aiImg" alt="" src="${artboard2Image}"/>
		  <div id="g-ai1-1" class="g-xs g-aiAbs" style="top:0.6652%;left:4.1681%;width:51.5152%;">
			  <p>Bicameral congress </p>
		  </div>
		  <div id="g-ai1-2" class="g-xs g-aiAbs" style="top:2.5658%;left:4.1681%;width:84.5455%;">
			  <p>Unicameral congress/ parliament </p>
		  </div>
		  <div id="g-ai1-3" class="g-xs g-aiAbs g-aiPointText" style="top:6.7838%;margin-top:-9.4px;left:0%;width:96px;">
			  <p class="g-pstyle0">40 years old</p>
		  </div>
		  <div id="g-ai1-4" class="g-xs g-aiAbs g-aiPointText" style="top:23.9843%;margin-top:-9.4px;left:0%;width:38px;">
			  <p class="g-pstyle0">45</p>
		  </div>
		  <div id="g-ai1-5" class="g-xs g-aiAbs" style="top:29.1743%;left:72.3166%;width:26.6667%;">
			  <p class="g-pstyle1">Belgium <span class="g-cstyle0">47.4</span></p>
		  </div>
		  <div id="g-ai1-6" class="g-xs g-aiAbs" style="top:36.2066%;left:0.4797%;width:22.4242%;">
			  <p class="g-pstyle1">Rwanda <span class="g-cstyle0">49</span></p>
		  </div>
		  <div id="g-ai1-7" class="g-xs g-aiAbs" style="top:36.3016%;left:73.3511%;width:25.1515%;">
			  <p class="g-pstyle1">Bahrain <span class="g-cstyle0">49.7</span></p>
		  </div>
		  <div id="g-ai1-8" class="g-xs g-aiAbs g-aiPointText" style="top:41.755%;margin-top:-9.4px;left:0%;width:38px;">
			  <p class="g-pstyle0">50</p>
		  </div>
		  <div id="g-ai1-9" class="g-xs g-aiAbs" style="top:42.9537%;left:72.2946%;width:31.2121%;">
			  <p class="g-pstyle1">Philippines <span class="g-cstyle0">51</span></p>
		  </div>
		  <div id="g-ai1-10" class="g-xs g-aiAbs g-aiPointText" style="top:58.1952%;margin-top:-9.4px;left:0%;width:38px;">
			  <p class="g-pstyle0">55</p>
		  </div>
		  <div id="g-ai1-11" class="g-xs g-aiAbs" style="top:60.2493%;left:59.4798%;width:21.8182%;">
			  <p><span class="g-cstyle1">Japan</span> 55.6</p>
		  </div>
		  <div id="g-ai1-12" class="g-xs g-aiAbs" style="top:66.5213%;right:56.2599%;width:21.8182%;">
			  <p class="g-pstyle2"><span class="g-cstyle1">US</span> 57.7</p>
		  </div>
		  <div id="g-ai1-13" class="g-xs g-aiAbs g-aiPointText" style="top:75.3007%;margin-top:-9.4px;left:0%;width:38px;">
			  <p class="g-pstyle0">60</p>
		  </div>
		  <div id="g-ai1-14" class="g-xs g-aiAbs g-aiPointText" style="top:92.4062%;margin-top:-9.4px;left:0%;width:38px;">
			  <p class="g-pstyle0">65</p>
		  </div>
		  <div id="g-ai1-15" class="g-xs g-aiAbs" style="top:94.7453%;left:41.0224%;width:30.6061%;">
			  <p class="g-pstyle1">Cambodia <span class="g-cstyle0">66.5</span></p>
		  </div>
	  </div>
  
	  <!-- Artboard: Artboard_3 -->
	  <div id="g-Parliament-Artboard_3" class="g-artboard" style="width:560px; height:216.07643240759px;" data-aspect-ratio="2.592" data-min-width="560" data-max-width="799">
  <div style=""></div>
		  <img id="g-Parliament-Artboard_3-img" class="g-Parliament-Artboard_3-img g-aiImg" alt="" src="${artboard3Image}"/>
		  <div id="g-ai2-1" class="g-sm g-aiAbs" style="top:3.2396%;left:2.9278%;width:20.8929%;">
			  <p>Bicameral congress </p>
		  </div>
		  <div id="g-ai2-2" class="g-sm g-aiAbs" style="top:3.2396%;left:27.3627%;width:39.6429%;">
			  <p>Unicameral congress/ parliament </p>
		  </div>
		  <div id="g-ai2-3" class="g-sm g-aiAbs g-aiPointText" style="top:19.818%;margin-top:-8.8px;left:18.1103%;width:36px;">
			  <p class="g-pstyle0">45</p>
		  </div>
		  <div id="g-ai2-4" class="g-sm g-aiAbs g-aiPointText" style="top:19.818%;margin-top:-8.8px;left:51.8687%;width:36px;">
			  <p class="g-pstyle0">55</p>
		  </div>
		  <div id="g-ai2-5" class="g-sm g-aiAbs g-aiPointText" style="top:19.818%;margin-top:-8.8px;left:85.6286%;width:36px;">
			  <p class="g-pstyle0">65</p>
		  </div>
		  <div id="g-ai2-6" class="g-sm g-aiAbs g-aiPointText" style="top:19.818%;margin-top:-8.8px;left:1.1849%;width:91px;">
			  <p class="g-pstyle0">40 years old</p>
		  </div>
		  <div id="g-ai2-7" class="g-sm g-aiAbs g-aiPointText" style="top:19.818%;margin-top:-8.8px;left:35.7767%;width:36px;">
			  <p class="g-pstyle0">50</p>
		  </div>
		  <div id="g-ai2-8" class="g-sm g-aiAbs g-aiPointText" style="top:19.818%;margin-top:-8.8px;left:68.878%;width:36px;">
			  <p class="g-pstyle0">60</p>
		  </div>
		  <div id="g-ai2-9" class="g-sm g-aiAbs" style="top:30.5447%;left:27.8166%;width:9.2857%;">
			  <p class="g-pstyle1">Bahrain</p>
		  </div>
		  <div id="g-ai2-10" class="g-sm g-aiAbs" style="top:32.8587%;left:37.2884%;width:15.3571%;">
			  <p class="g-pstyle1">Philippines <span class="g-cstyle0">51</span></p>
		  </div>
		  <div id="g-ai2-11" class="g-sm g-aiAbs" style="top:41.1891%;left:54.0614%;width:13.3929%;">
			  <p><span class="g-cstyle1">Japan</span> 55.6</p>
		  </div>
		  <div id="g-ai2-12" class="g-sm g-aiAbs" style="top:47.2055%;left:88.112%;width:11.9643%;">
			  <p class="g-pstyle1">Cambodia</p>
			  <p>66.5</p>
		  </div>
		  <div id="g-ai2-13" class="g-sm g-aiAbs" style="top:74.9735%;left:58.6784%;width:10.3571%;">
			  <p><span class="g-cstyle1">US</span> 57.7</p>
		  </div>
		  <div id="g-ai2-14" class="g-sm g-aiAbs" style="top:86.0807%;left:20.2084%;width:12.3214%;">
			  <p class="g-pstyle1">Rwanda <span class="g-cstyle0">49</span></p>
		  </div>
	  </div>
  
  </div>
  
  <!-- End ai2html - 2025-03-08 07:05 -->
  
  `;

  return (
    <div 
      className="parliament-chart-container"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

export default Parliament;